import React, { useState } from 'react';
import PeopleList from './PeopleList';
import SchoolsTable from './SchoolsTable';
import './Resources.css';

const Resources = () => {
  const [activeTab, setActiveTab] = useState('people');

  return (
    <div className="resources-page-wrapper">
      <div className="sidebar">
        <div
          className={`tab-item ${activeTab === 'people' ? 'active' : ''}`}
          onClick={() => setActiveTab('people')}
        >
          People
        </div>
        <div
          className={`tab-item ${activeTab === 'schools' ? 'active' : ''}`}
          onClick={() => setActiveTab('schools')}
        >
          Schools
        </div>
      </div>
      <div className="content-area">
        <h1>Resources</h1>
        {activeTab === 'people' && <PeopleList />}
        {activeTab === 'schools' && <SchoolsTable />}
      </div>
    </div>
  );
};

export default Resources;